<h1 mat-dialog-title>{{ title }} <br> <h4>Absorción Acida</h4></h1>
<hr>
<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
    <mat-dialog-content>
        <div class="container-fluid">
            <div class="row">
                <!-- Características -->
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Características</mat-label>
                        <input matInput formControlName="caracteristicas" placeholder="Características"
                            (blur)="form.controls['caracteristicas'].markAsTouched()" uppercase alphanumericOnly maxlength="250">
                        <mat-error *ngIf="isValidField('caracteristicas')">
                            {{ getFieldError('caracteristicas') }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <!-- Realizo -->
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Realizo</mat-label>
                        <mat-select formControlName="realizo">
                            <mat-option value="ANTES DE LIMPIEZA">ANTES DE LIMPIEZA</mat-option>
                            <mat-option value="DESPUÉS DE LIMPIEZA">DESPUÉS DE LIMPIEZA</mat-option>
                        </mat-select>
                        <mat-error *ngIf="isValidField('realizo')">
                            {{ getFieldError('realizo') }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="text-right">
                <button mat-raised-button color="primary" class="m-1" type="submit">
                    <i class="fa fa-plus"></i> Agregar
                </button>
            </div>
        </div>
    </mat-dialog-content>
</form>

<!-- TABLA -->
<section class="content p-0">
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table id="table-1" mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                        <!-- Columna Característica -->
                        <ng-container matColumnDef="caracteristicas">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Características</th>
                            <td mat-cell *matCellDef="let row">{{ row?.carateristica }}</td>
                        </ng-container>

                        <!-- Columna Realizo -->
                        <ng-container matColumnDef="realizo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Realizo</th>
                            <td mat-cell *matCellDef="let row">{{ row?.realiza }}</td>
                        </ng-container>

                        <!-- Columna Opciones -->
                        <ng-container matColumnDef="options">
                            <th mat-header-cell *matHeaderCellDef> Opciones </th>
                            <td mat-cell *matCellDef="let row" class="catalog-list-options">
                                <button mat-icon-button color="primary"  aria-label="Modificar" (click)="update(row)">
                                    <mat-icon>border_color</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <br />
                <mat-paginator [pageSize]="4" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            </div>
        </div>
    </div>
</section>

<!-- BOTÓN CERRAR -->
<div class="text-right mt-3 p-3">
    <button mat-raised-button color="warn" mat-dialog-close>
        <i class="fa fa-remove fa-solid"></i> Cerrar
    </button>
</div>
